import { render, staticRenderFns } from "./copyUserTable.vue?vue&type=template&id=f1c53c84&scoped=true&"
import script from "./copyUserTable.vue?vue&type=script&lang=js&"
export * from "./copyUserTable.vue?vue&type=script&lang=js&"
import style0 from "./copyUserTable.vue?vue&type=style&index=0&id=f1c53c84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c53c84",
  null
  
)

export default component.exports